import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Icon } from "antd";
import $ from "jquery";
import { ssoUrl } from "../../common/baseConfig";
import { topicTeacherImgs } from '../../images/topicImg';
import LoginModal from "./LoginModal";
import TopSerach from './TopSerach'


export class TopicHeader extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    isShowHeadChunk: false,
    isShowLoginModal: false,
    isFixed: false,
  }
  timer = null;
  componentWillMount() {
    this.isScroll = false;
    //滚动监听是否固定header
    window.addEventListener('scroll', this.handleScroll.bind(this), true);

    let studentinfo = localStorage.getItem("studentinfo");
    if (studentinfo) {
      this.props.actions.fetchGetShoppingCar();
    }
    if (this.props.history.location.pathname === "/center") {
      this.props.actions.fetchCheckGuide().then(res => {
        if (res.SuccessResponse && !res.Data) {
          this.setState({
            isShowHeadChunk: true,
          })
        }
      })
    }

    //获取听课记录
    if (localStorage.getItem('studentinfo')) {
      this.props.actions.fetchGetLookInfo();
    }
    this.props.actions.fetchGetConfiguration();
  }
  componentDidMount() {
    let _this = this;
    window.addEventListener('setItemEvent', (e) => {
      //顶部菜单栏监听是否弹出登录框
      if (e.key === 'showLoginModal' && e.newValue) {
        _this.setState({
          isShowLoginModal: true
        })
      }
    })
    //拉取微信二维码
    this.props.actions.fetchGetWeAppCode();
    //拉取公众号二维码
    this.props.actions.fetchGetPublicAccount();
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.isScroll && nextState.isFixed === this.state.isFixed) {
      return false;
    }
    return true;
  }
  handleScroll() {
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    this.isScroll = true;
    this.setState({
      isFixed: scrollTop > 45
    }, () => {
      this.isScroll = false;
    })
  }
  _isShowHeadChunk(str) {
    clearTimeout(this.timer);
    if (str === 'leave') {
      this.timer = setTimeout(() => {
        this.setState({
          isShowHeadChunk: false
        })
      }, 500)
    } else {

      this.setState({
        isShowHeadChunk: true
      })
    }
  }
  // _headerLeftItem(menus) {

  //   const routingMatch = (url) => {
  //     let { pathname } = this.props.location;
  //     if (pathname.includes('courseList')) {
  //       pathname = '/courseList/0-0-0'
  //     }
  //     return pathname === url;
  //   }
  //   return menus.map((item, index) => {
  //     let { MenuShowType = 0, MenuUrl = '', UrlType = '0', MenuName = '' } = item;
  //     if (index === 0) {
  //       MenuUrl = "/";
  //     }
  //     return (
  //       item.MenuValid === 1 ?
  //         <li key={index} className='nav_item'>
  //           <a href={MenuUrl || '#'} target={UrlType === 1 ? '_blank' : ''} className={routingMatch(MenuUrl) ? "nav_item_active" : ""} >{MenuName}</a>
  //           {MenuShowType === 1 ?
  //             <div className='nav_item_code'>
  //               <img alt="" className='nav_item_img' src={MenuUrl} />
  //             </div>
  //             :
  //             <span></span>
  //           }
  //         </li>
  //         : ''
  //     )
  //   })
  // }
  _headchunk() {
    const { studentBasics = null } = this.props
    const MyLessonRecords = this.props.courseLookInfo
    let { HeadImg = null, AddTime = '', Phone = '' } = studentBasics || {}
    if (AddTime.length > 0) {
      const TIndex = AddTime.indexOf('T')
      AddTime = AddTime.slice(0, TIndex)
    }
    return (
      <div onMouseLeave={() => this._isShowHeadChunk('leave')} onMouseEnter={() => this._isShowHeadChunk('enter')} className='head_chunk'>
        <div className='head_chunk_content'>
          <div className='head_chunk_content_top'>
            <img onClick={() => this.gotoConsole()} alt="" className='head_chunk_top_left' src={HeadImg || require('../../images/head.png')} />
            <div className='head_chunk_top_right'>
              <p className='head_chunk_top_right_phone'>{Phone}</p>
              <p className='head_chunk_top_right_time'>{AddTime}</p>
            </div>
          </div>
          <ul className='head_chunk_list'>
            <li className='head_chunk_list_item'>
              <Link to="/center/courseManage/3">
                <img alt="" className='head_chunk_list_img' src={require('../../images/star.png')} />
                <p className='head_chunk_list_item_text'>我的收藏</p>
              </Link>
            </li>
            <li className='head_chunk_list_item'>
              <Link to="/center/myOrder/0" >
                <img alt="" className='head_chunk_list_img' src={require('../../images/order_icon.png')} />
                <p className='head_chunk_list_item_text'>订单中心</p>
              </Link>
            </li>
            <li className='head_chunk_list_item'>
              <Link to="/center/courseManage/0">
                <img alt="" className='head_chunk_list_img' src={require('../../images/video.png')} />
                <p className='head_chunk_list_item_text'>我的课程</p>
              </Link>
            </li>
          </ul>

          {MyLessonRecords && MyLessonRecords.length > 0 ? <div className='head_chunk_continue'>
            <div className='head_chunk_continue_headLine'><Icon style={{ fontSize: '14px', marginTop: '2px', color: '#999' }} type="clock-circle" /><p className='head_chunk_continue_headLine_text'>&nbsp;&nbsp;{MyLessonRecords[0][0].Name || ''}</p></div>
            <div className='head_chunk_continue_title'>
              <p>{MyLessonRecords[0][0].ChapterName || ''}</p>
              <Link to={`/course/video/${MyLessonRecords[0][0].ID}-${MyLessonRecords[0][0].CourseChapters_ID}-${MyLessonRecords[0][0].WareId}`} className='head_chunk_continue_again'>继续</Link>
            </div>
          </div> : ''}
        </div>
        <input onClick={() => this.onLoginOut()} className='head_chunk_out' type="button" value="安全退出" />
      </div>
    )
  }
  gotoLogin() {
    this.props.history.push('/login') // 登录判断
  }
  gotoRegister() {
    this.props.history.push('/register') // 注册判断
  }
  gotoConsole() {
    this.props.history.push('/center')
  }
  onLoginOut() {
    $.ajax({
      type: "POST",
      url: ssoUrl + "/sso/ssostudent/logout",
      xhrFields: { withCredentials: true },
      crossDomain: true,
    });
    this.props.actions.fetchLogout();
    this.props.actions.fectchLoginOut();
    this.props.history.replace('/login');
    this.props.actions.clearCartCount();
  }
  render() {
    const { fetchGetHeaderSuccess = {}, fetchGetConfigurationSuccess } = this.props.common;

    if (!fetchGetHeaderSuccess) { return '' }
    const { studentBasics = {} } = this.props
    const studentBasicsKeyList = Object.keys(studentBasics)
    const isLogin = studentBasicsKeyList.length > 0 ? true : false
    const { pathname } = this.props.location;
    const { BackColor = '', LogoUrl = '', } = fetchGetHeaderSuccess || {}
    let { HeadImg = null } = studentBasics || {}
    const { isShowHeadChunk, isFixed, isShowLoginModal } = this.state;
    return (
      <div className={`common-header`}>
        <div className={`content_wrap_1 ${isFixed ? "content_wrap_shadow" : ""}`}>
          <header className='model_header'>
            {/* <ul className={`model_header_left nav`}>
              {this._headerLeftItem(menus)}
            </ul> */}
            <div className='model_header_left nav'>
              <img src={topicTeacherImgs.topic_logo} alt=""/>
            </div>
            <ul className={`model_header_right nav`}>
              {/* <li className={pathname === '/cart' ? "model_header_right_cart_active step6" : "model_header_right_cart step6"} onClick={() => this.props.history.push('/cart')}>
                <MyIcon className="cart addCartBtn" type="icongouwuche_" />
                <span className="txt">购物车</span>
                <Badge className="count" count={fetchGetShoppingCarTotal} />
              </li> */}
              {isLogin ?
                <li className='nav_item topic_a'>
                  <a onClick={() => this.gotoConsole()} onMouseLeave={() => this._isShowHeadChunk('leave')} onMouseEnter={() => this._isShowHeadChunk('enter')} className='my_head'>
                    <img alt="" className='head_img step2' src={HeadImg || require('../../images/head.png')} />
                  </a>
                  {isShowHeadChunk ? this._headchunk() : ''}
                </li>
                : <li className='nav_item topic_a'>
                  <a className={pathname === '/login' ? 'nav_item_active' : ''} href="" onClick={() => this.gotoLogin()} >登录</a>
                  <span className={`nav_item_slash`}>/</span>
                  {fetchGetConfigurationSuccess && fetchGetConfigurationSuccess.RegisterValid === 1 && <a className={pathname === '/register' ? 'nav_item_active' : ''} href="" onClick={() => this.gotoRegister()} >注册</a>}</li>
              }
            </ul>
          </header>
        </div>
        {this.props.location.pathname === '/' ? <TopSerach {...this.props} logUrl={LogoUrl} BackColor={BackColor} /> : ''}
        <LoginModal visible={isShowLoginModal} onCancel={() => { this.setState({ isShowLoginModal: false }) }} />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
    studentBasics: state.common.studentBasics,
    courseLookInfo: state.center.fetchGetLookInfoSuccess,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopicHeader);



// WEBPACK FOOTER //
// ./src/features/common/TopicHeader.js